import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter, Link } from 'react-router-dom';
import get from 'lodash.get';
import { push } from 'react-router-redux';

import { fetchTransactions } from 'modules/transactions';

import Messages from 'components/Messages';
import LoadingOverlay from 'components/LoadingOverlay';
import Pagination from 'components/Pagination';

import Item from './item';

class TransactionsPage extends Component {
  static propTypes = {
    dispatch: PropTypes.func.isRequired,
    isLoading: PropTypes.bool.isRequired,
    error: PropTypes.bool.isRequired,
    errors: PropTypes.object.isRequired,
    transactions: PropTypes.array.isRequired,
    totalPages: PropTypes.number.isRequired,
  };

  componentDidMount() {
    const { isLoading, dispatch } = this.props;

    // Do not fetch request if request already sent
    if (!isLoading) {
      let page = 1;

      // Check if page params is exists
      if (get(this.props.match, 'params.page')) {
        page = this.props.match.params.page;
      }

      dispatch(fetchTransactions({ page }));
    }
  }

  /**
   * Page Changes
   */
  componentWillReceiveProps(nextProps) {
    // Check if page params is exists
    if (get(nextProps.match, 'params.page')) {
      const { isLoading, dispatch, match } = this.props;
      const page = nextProps.match.params.page;

      // Make sure page is different
      if (page !== match.params.page) {
        // Do not fetch request if request already sent
        if (!isLoading) {
          dispatch(fetchTransactions({ page }));
        }
      }
    }
  }

  onPageChange = (props) => {
    const page = props.selected + 1;
    this.props.dispatch(push(`/transactions/page/${page}`));
  };

  renderTable() {
    const { transactions } = this.props;

    if (transactions.length > 0) {
      return (
        <table className="payout-history-table transaction-table custom-table">
          <thead>
            <tr>
              <th>ID</th>
              <th>Tanggal</th>
              <th>Nominal</th>
            </tr>
          </thead>
          <tbody>{transactions.map(data => <Item key={data.ID} data={data} />)}</tbody>
        </table>
      );
    }

    return <Messages>Belum adalah riwayat transaksi</Messages>;
  }

  render() {
    const { isLoading, totalPages, match } = this.props;
    const showLoading = isLoading ? 'show' : '';
    let page = 1;

    // Check for page params
    if (get(match, 'params.page')) {
      page = parseInt(match.params.page, 10);
    }

    return (
      <div className={`form-wrapper content-wrapper ${showLoading}`}>
        <div className="form-wrapper__inner">
          <div className="entry-header">
            <h2 className="block-title">Riwayat Transaksi</h2>
            <div className="text-medium text-color-gray-1 mb-30">
              Berikut adalah riwayat transaksi pelanggan yang menggunakan Dealpay di toko anda.
            </div>
            <div className="text-medium text-color-gray-1 mb-30">
              Lebih suka melihat data dalam bentuk grafik?<br />
              <br />
              <Link className="button button--secondary button--small " to="/transactions/graph">
                Lihat Grafik
              </Link>
            </div>
          </div>

          {!isLoading && this.renderTable()}

          <Pagination
            totalPages={totalPages}
            initialPage={page - 1}
            onPageChange={this.onPageChange}
          />
        </div>

        <LoadingOverlay />
      </div>
    );
  }
}

const mapStateToProps = ({ transactions }) => ({
  ...transactions,
});

export default withRouter(connect(mapStateToProps)(TransactionsPage));



// WEBPACK FOOTER //
// ./src/pages/Transactions/index.js